import React, { useState } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./app.css";
import { Myinput, Mylogo, ModalDetailforget } from "../Useful/Useful";
import Raeenlogo from "../../img/Raeenlogo.png";
import web from "../../img/web.jpg";
import { Button, Form } from "reactstrap";
import "react-awesome-slider/dist/styles.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RecoverPass } from "../../fetch";
import { useHistory } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function SimpleModal(props) {
  const classes = useStyles();
  const history = useHistory();
  const [pass, setPass] = useState("");
  const [openModal, setopenModal] = useState(false);
  const [newPass, setNewPass] = useState({
    PhoneNumber: "",
    ForgetPasswordCode: "",
    NewPassword: "",
    RepeatNewPassword: "",
  });

  const {
    PhoneNumber,
    ForgetPasswordCode,
    NewPassword,

    RepeatNewPassword,
  } = newPass;

  function handleSubmit(e) {
    e.preventDefault();
    // if (e.target.phoneNumber.value === "" || e.target.password.value === "") {
    //   toast.error("نام کاربری یا کلمه عبور وارد نشده است");
    //   return false;
    // }

    RecoverPass({
      PhoneNumber: PhoneNumber,
      ForgetPasswordCode: ForgetPasswordCode,
      NewPassword: NewPassword,
      RepeatNewPassword: RepeatNewPassword,

      //   password: e.target.password.value,
    })
      .then((response) => {
        if (response.status == 200) {
          toast.success("رمز عبور جدید با موفقیت ثبت شد");
          history.push("/login");
        } else {
          toast.error(" خطای ثبت رمز عبور جدید ");
        }
        return response.json();
      })
      .then((responseJson) => {
        setPass(responseJson.result.password);

        //  history.push("/MailListItem");
      })
      .catch((error) => {
        console.log(error);
        toast.error("خطای ارتباط با سرور");
        return false;
      });
  }

  const handleChange = (name) => (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    event.persist();
    setNewPass((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <div class="col-12 backLogin">
      <div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 col-md-8 col-sm-12 col-xs-12 menuLogin shadow  ">
          <div class="row ">
            <div class="col d-flex justify-content-center align-center ">
              <Form onSubmit={handleSubmit}>
                <Mylogo class="logoSize" src={Raeenlogo} alt="logo" />
                <h5> ایجاد کلمه عبور جدید</h5>
                <div className="col">
                  <div className="form-group textg">
                    <label
                      className="control-label"
                      htmlFor="ForgetPasswordCode"
                    >
                      کد بازیابی{" "}
                    </label>
                    <input
                      type="text"
                      // ref={this.fileInput}
                      value={ForgetPasswordCode}
                      id="ForgetPasswordCode"
                      onChange={handleChange("ForgetPasswordCode")}
                      className="contactInput form-control"
                      name="ForgetPasswordCode"
                      placeholder=" کد بازیابی ..."
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="PhoneNumber">
                      شماره تماس{" "}
                    </label>
                    <input
                      type="number"
                      // ref={this.fileInput}
                      value={PhoneNumber}
                      id="PhoneNumber"
                      onChange={handleChange("PhoneNumber")}
                      className="contactInput form-control"
                      name="PhoneNumber"
                      placeholder=" شماره تماس ..."
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="NewPassword">
                      رمز عبور جدید{" "}
                    </label>
                    <input
                      type="password"
                      // ref={this.fileInput}
                      value={NewPassword}
                      id="NewPassword"
                      onChange={handleChange("NewPassword")}
                      className="contactInput form-control"
                      name="NewPassword"
                      placeholder="رمز عبور جدید  ..."
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group textg">
                    <label
                      className="control-label"
                      htmlFor="RepeatNewPassword"
                    >
                      تکرار رمز عبور جدید{" "}
                    </label>
                    <input
                      type="password"
                      // ref={this.fileInput}
                      value={RepeatNewPassword}
                      id="RepeatNewPassword"
                      onChange={handleChange("RepeatNewPassword")}
                      className="contactInput form-control"
                      name="RepeatNewPassword"
                      placeholder="تکرار رمز عبور جدید  ..."
                    />
                  </div>
                </div>

                <Button color="primary" size="sm" id="loginidbtn" type="submit">
                  ارسال
                </Button>
                {/* <Modal open={openModal} /> */}
              </Form>
            </div>
          </div>
          {/* <Link to='/login'>بازگشت به صفحه ورود</Link> */}
        </div>
        <div class="col-lg-3"></div>
      </div>
    </div>
  );
}
